<template>
  <v-card
    class="d-flex-row justify-space-around align-center my-0 py-2 px-3"
    elevation="0"
  >
    <div style="width: 100%">
      <v-card-title class="card-title pl-0">
        <v-icon class="pr-2" @click="voltar" color="#BC0000"> mdi-arrow-left </v-icon>
        Configurações
      </v-card-title>
      <v-card-text class="card-text"> Altere suas informações de cadastro </v-card-text>
    </div>

    <div class="d-flex my-0 px-5" style="justify-content: flex-end">
      <v-btn
        class="header-button hidden-sm-and-down"
        v-if="haveAction"
        color="#2D3038"
        elevation="2"
        @click="action"
        >Novo revendedor</v-btn
      >

      <v-btn
        fab
        tile
        small
        class="header-button hidden-md-and-up"
        v-if="haveAction"
        color="#2D3038"
        elevation="2"
        @click="action"
      >
        <v-icon>mdi-plus</v-icon></v-btn
      >

      <v-btn
        class="header-button hidden-sm-and-down"
        v-if="haveAction"
        color="normalred"
        elevation="0"
        @click="action2"
        >Importar revendedores</v-btn
      >

      <v-btn
        fab
        tile
        small
        class="header-button hidden-md-and-up"
        v-if="haveAction"
        color="normalred"
        elevation="2"
        @click="action2"
      >
        <v-icon>mdi-cloud-upload</v-icon></v-btn
      >
    </div>
  </v-card>
</template>

<style scoped>
.card-title {
  font-family: Roboto;
  font-size: 1.5rem !important;
}

.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1rem;
  font-weight: 300;
  line-height: 30px;

  width: 70%;

  color: #9c9c9c;
}

.v-btn {
  font-weight: bold;
  width: 250px;
  border-radius: 10px;
  height: 47px;
}

@media (max-width: 500px) {
  .card-title {
    font-size: 1.1rem !important;
    padding: 0;
  }

  .card-text {
    font-size: 0.9rem !important;
    width: 80%;
  }
}
@media (max-width: 900px) {
  .card-title {
    font-size: 2rem;
    padding: 0;
  }

  .card-text {
    font-size: 0.9rem;
    width: 80%;
  }
}
</style>

<script>
export default {
  name: "HeaderCard",

  props: {
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
  },

  methods: {
    action() {
      this.$emit("action");
    },

    action2() {
      this.$emit("action2");
    },

    voltar() {
      this.$emit("voltar");
    },
  },
};
</script>
